/**
 * 데스크톱 글로벌 헤더 좌측 GNB에 사용하는 메뉴 정의
 */
export interface DesktopNavMenuItem {
  id: string;
  text: string;
  to: string;
  params?: Record<string, string>;
}

export const DESKTOP_NAV_MENUS: DesktopNavMenuItem[] = [
  { id: 'home', text: '홈', to: 'home' },
  { id: 'order', text: '주문', to: 'order' },
  { id: 'trade', text: '거래', to: 'transaction', params: { transactionTab: 'order' } },
  { id: 'assets', text: '자산', to: 'asset' },
  {
    id: 'account-management',
    text: '계좌관리',
    to: 'account-management',
    params: { accountManagementTab: 'create' },
  },
  { id: 'support', text: '고객지원', to: 'support', params: { supportTab: 'notice' } },
];
